import React, { useEffect, useRef } from "react";
import {
  consentMappingKeys,
  FormBuilderElementsMappingService
} from "../../../../services/builder/form-builder.elements-mapping.service";
import { useFormData } from "../../../../hooks/client/use-form-data";
export const loyaltyTermsAndConditionsLabelKey = "FORM.INPUT INPUT-LOYALTY-SIGN-UP.TERMS-AND-CONDITIONS_LABEL";
export const loyaltyTermsAndConditionsURLKey = "FORM.INPUT INPUT-LOYALTY-SIGN-UP.TERMS-AND-CONDITIONS_URL";
export const loyaltyPrivacyPolicyLabelKey = "FORM.INPUT INPUT-LOYALTY-SIGN-UP.PRIVACY-POLICY-LABEL";
export const loyaltyPrivacyPolicyURLKey = "FORM.INPUT INPUT-LOYALTY-SIGN-UP.PRIVACY-POLICY-URL";
const FormBuilderFormInterfaceLoyaltySignUp = ({ item, analyticForm, t }) => {
  if (!item) return null;
  const { formData, formDataSetters } = useFormData();
  const inputRef = useRef();
  const { input: checkbox, label } = FormBuilderElementsMappingService.getSingleElementHTMLTags(item);
  const defaultChecked = (formData == null ? void 0 : formData[checkbox.name]) === checkbox.value;
  const dataMapping = checkbox == null ? void 0 : checkbox["data-mapping"];
  const dataMappingObj = dataMapping ? JSON.parse(dataMapping) : {};
  const isRelatedElementEmpty = !(formData == null ? void 0 : formData[dataMappingObj == null ? void 0 : dataMappingObj[consentMappingKeys.MEMBER_ID]]);
  const onFocus = () => {
    analyticForm == null ? void 0 : analyticForm.trackInputFocused(checkbox.name);
  };
  const onBlur = () => analyticForm == null ? void 0 : analyticForm.trackInputBlurred(checkbox.name);
  useEffect(() => {
    const loyaltyInputElement = inputRef.current;
    if (loyaltyInputElement) {
      if (isRelatedElementEmpty) {
        loyaltyInputElement.disabled = true;
        loyaltyInputElement.checked = false;
        formDataSetters.setInputValue(checkbox.name, void 0);
      } else {
        loyaltyInputElement.disabled = false;
      }
    }
  }, [checkbox, isRelatedElementEmpty]);
  const termsAndConditionsLink = `<a href="${t(loyaltyTermsAndConditionsURLKey)}" target="_blank">${t(
    loyaltyTermsAndConditionsLabelKey
  )}</a>`;
  const privacyPolicyLink = `<a href="${t(loyaltyPrivacyPolicyURLKey)}" target="_blank">${t(
    loyaltyPrivacyPolicyLabelKey
  )}</a>`;
  const textHtml = t(label.nodeValue, {
    terms_link: termsAndConditionsLink,
    privacy_policy_link: privacyPolicyLink
  });
  return /* @__PURE__ */ React.createElement("div", { className: `${item.class}` }, /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: inputRef,
      type: checkbox == null ? void 0 : checkbox.type,
      name: checkbox == null ? void 0 : checkbox.name,
      onFocus,
      onBlur,
      defaultChecked,
      id: checkbox == null ? void 0 : checkbox.id,
      required: checkbox == null ? void 0 : checkbox.required,
      value: checkbox.value
    }
  ), /* @__PURE__ */ React.createElement("label", { htmlFor: label.for, dangerouslySetInnerHTML: { __html: textHtml } }));
};
FormBuilderFormInterfaceLoyaltySignUp.displayName = "FormBuilderFormInterfaceLoyaltySignUp";
export default FormBuilderFormInterfaceLoyaltySignUp;
